module.exports = __webpack_public_path__ + "assets/images/img_claim_box.png";